var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d2-error-log-list__expand",class:_vm.className},[_c('p',{staticClass:"d2-error-log-list__expand-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"d2-error-log-list__expand-value"},[_vm._v(_vm._s(_vm.value === '' ? '无数据' : _vm.value))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }